import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import LandingPage from './containers/LandingPage';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import Logout from './containers/Auth/Logout';
import OnBoarding from './containers/Onboarding/OnBoarding';
import NavTabs from './containers/NavTabs/NavTabs';
import ArbitrationAgreementsList from './components/ArbitrationAgreementsList';
import ArbitrationAgreementsPrint from './components/ArbitrationAgreementsPrint';
import ArbitrationFeeCalculator from './components/ArbitrationFeeCalculator';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CaseDialog from './containers/CaseSelection/CasesDialog';
import NewCaseDialog from '../src/containers/NavTabs/newCaseDialog';
import LoginForm from '../src/containers/Auth/LoginForm';
import MainPanel from '../src/containers/NavTabs/MainPanel'
import MainChatbot from './containers/Onboarding/MainChatbot'
import ArbitrationRulesMain from './components/ArbitrationRulesMain';
import ArbitrationListForView from '../src/components/ArbitrationListForView';
import ArbitrationAgreement from '../src/components/ArbitrationAgreement'
import SuggestedDocumentList from '../src/containers/NavTabs/SuggestedDocumentList'
import ChatbotResponse from './containers/Onboarding/ChatbotResponse';
import SignatureCanvasWrapperForManagerSign from './containers/Onboarding/SignatureCanvasWrapperForManagerSign';
import I18n from "redux-i18n";
import {translations} from "./translations";
import UploadDocs from './containers/Onboarding/UploadDocs';
import MainPanelRoute from './containers/NavTabs/MainPanelRoute';
import DocumentUploadPage from './containers/DocumentUploadPage';

 
import {
    HashRouter as Router,
    // BrowserRouter as Router,
    Route,
    Link,
    Redirect,
    Switch,
  } from 'react-router-dom';
import { camelCase } from 'lodash';
import UsefulItem from './components/usefulItem';
import ForgetPasswordForm from './containers/Auth/ForgetPasswordForm';
console.log('language set: '+localStorage.getItem('language'))
let usefulItems = ['About Online Arbitration', 'Arbitrators’ List', 'Arbitration Rules', 'Arbitration Procedure', 'Arbitration Agreement', 'Online Arbitration Clauses', 'Arbitration Fee Calculator', 'FAQ'];
let usefulItemsURLs = ['About Online Arbitration', 'Arbitrators’ List', 'Arbitration Rules', 'Arbitration Procedure', 'Arbitration Agreement', 'Online Arbitration Clauses', 'FAQ'];

const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#B71C1C',
      },
      //secondary: green,
    },
    status: {
      danger: 'orange',
    },
    typography: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: 14,
      display4: {
        fontSize: 14,
      },
      display3: {
        fontSize: 14,
      },
      display2: {
        fontSize: 14,
      },
      display1: {
        fontSize: 14,
      },
      headline: {
        fontSize: 14,
      },
      title: {
        fontSize: 14,
      },
      subheading: {
        fontSize: 14,
      },
      body2: {
        fontSize: 14,
      },
      body1: {
        fontSize: 14,
      },
      caption: {
        fontSize: 14,
      },
      button: {
        fontSize: 14,
      },
      subtitle1:{
        fontSize: 13,
      },
    },
  });

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <I18n translations={translations} initialLang={ (localStorage.getItem('language') !== null) ? localStorage.getItem('language'): "en" }>
            <Router>
                <Switch>
                  <Route path='/cases/:id/onBoarding' component={OnBoarding} />
                  <Route path='/cases/:id/home' component={MainPanelRoute} />
                  <Route path='/arbitrationAgreements' component={ArbitrationAgreementsList} />
                  <Route path='/arbitrationRulesMain' component={ArbitrationRulesMain} />
                  <Route path='/ArbitrationAgreementsPrint' component={ArbitrationAgreementsPrint} />
                  <Route path='/cases/:id' component={App} />
                  <Route path='/forgetPassword' component={ForgetPasswordForm} />  
                  <Route path='/logout' component={Logout} /> 
                  <Route path='/cases' component={CaseDialog} /> 
                  <Route path='/NewCases' component={NewCaseDialog} /> 
                  <Route path='/login' component={LoginForm} /> 
                  <Route path='/chatbot' component={MainChatbot} /> 
                  <Route path='/arbitrationListForView' component={ArbitrationListForView} /> 
                  <Route path='/arbitrationAgreement' component={ArbitrationAgreement} /> 
                  <Route path='/suggestedDocumentList' component={SuggestedDocumentList} /> 
                  <Route path='/ChatbotResponse' component={ChatbotResponse} /> 
                  <Route path='/documentUpload' component={DocumentUploadPage} /> 
                  <Route path='/caseSignatuePage/:token/:conversationId/:uniqueId/:caseId' component={SignatureCanvasWrapperForManagerSign} /> 

                  {/* <Route path='/reenterdata' component={ChatbotReEnterData} />  */}
                  {/* <Route path='/onBoarding' component={App} /> */}
                  {/*
                      usefulItemsURLs.map((title, index) => (
                          <Route
                              key={index}
                              path={'/' + camelCase(title)}
                              render={() => <UsefulItem title={title}/>}
                          />
                      ))
                      */}
                  {/* <Route path='/arbitrationRules' component={ArbitrationRules} />  */}
                  {/* <Route path='/arbitrationFeeCalculator' component={ArbitrationFeeCalculator} />  */}
                  <Route exact path='/' render={() => <div><LandingPage usefulItems={usefulItems}/></div>} />                                        
                </Switch>
            </Router>
          </I18n>
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
